<template>
  <div>
    Filter: <input v-model="ls.filterQuery">
    <a :href="$voidHref" v-on:click="loadData()">🔄 Refresh Data</a>
    
    <div v-if="inventory.length === 0">
      <!-- Placeholder while loading -->
      Loading...
      <br><br><br><br><br><br>
    </div>

    <table v-if="inventory.length > 0" style="width:500px;">
      <tr>
        <th>&nbsp;</th>
        <th v-for="key in ['ItemNum', 'ItemName', 'ItemName_Extra', 'Dept', 'Cat', 'Vendor', 'Vendor #', 'Price', 'Cost', 'Num / Case', 'Size', 'Size Type']" :key="key">
          {{key}}
        </th>
      </tr>
      <tr v-for="(row, index) in filteredInventory" :key="index">
        
        <td>
          <div>  
            <div v-if="!row.meta.isEditing">
              <a href="javascript:void(0);" v-on:click="willEdit(row)">edit</a>
              <a href="javascript:void(0);" v-on:click="toggleAdvanced(row)">⚙️</a>
              <div v-if="row.meta.showAdvanced">
                <div v-for="key in $locations" :key="key">
                  <a href="javascript:void(0);" v-on:click="willClone(row, key)">
                    Clone to {{key}}
                  </a>
                </div>
              </div>
            </div>  
            <div v-if="row.meta.isEditing">
              <a href="javascript:void(0);" v-on:click="saveEdit(row)">save</a>
            </div>  
            <div v-if="row.meta.isCloning">
              <a href="javascript:void(0);" v-on:click="saveClone(row)">save</a>
            </div>  
          </div>
        </td>
        
        <td>
          <div v-if="row.meta.isCloning">
            <input type="text" v-model="row.data.ItemNum">
          </div>
          <div v-else>
            {{row.data.ItemNum}}
          </div>
        </td>

        <td>
          <div v-if="row.meta.isEditing || row.meta.isCloning">
            <input type="text" v-model="row.data.ItemName">
          </div>
          <div v-else>
            {{row.data.ItemName}}
          </div>
        </td>

        <td>
          <div v-if="row.meta.isEditing || row.meta.isCloning">
            <input type="text" v-model="row.data.ItemName_Extra">
          </div>
          <div v-else>
            {{row.data.ItemName_Extra}}
          </div>
        </td>

        <td>
          <div v-if="row.meta.isEditing || row.meta.isCloning">
            <input type="text" v-model="row.data.Dept_ID">
          </div>
          <div v-else>
            {{row.data.department.Description}}
          </div>
        </td>
        <td>
          <div v-if="row.meta.isEditing || row.meta.isCloning">
            <input type="text" v-model="row.data.Dept_ID">
          </div>
          <div v-else>
            {{row.data.department.category.Description}}
          </div>
        </td>

        
        <!-- Reorder_Quantity is actually the number per case -->
        <td v-for="key in ['Vendor_Number', 'Vendor_Part_Num', 'Price', 'Cost', 'Reorder_Quantity', 'Unit_Size', 'Unit_Type']" :key="key">
          <div v-if="row.meta.isEditing || row.meta.isCloning">
            <input type="text" v-model="row.data[key]">
          </div>
          <div v-else>
            {{row.data[key]}}
          </div>
        </td>
        
      </tr>
    </table>
  </div>
</template>

<script>
import localstorageMixin from '@/mixins/localstorageMixin.js'
export default {
  name : 'InventoryCRUD',
  mixins: [localstorageMixin],
  data () { return {
    ls: {
      filterQuery: "Vype"
    }, 
    inventory: [],
    inventorySkus: [],
    inventorySkusObject: {},
    } 
  },
  async created () {
    this.loadData();
  },
  props : ['location', 'departments'],
  watch : {
    location: function(val){
      this.loadData()
    }
  },
  methods : {
    loadData : function(){
      this.inventory = [];
      
      const options = {attributes:['ItemNum', 'ItemName', 'ItemName_Extra','Dept_ID', 'Vendor_Number', 'Vendor_Part_Num', 'Price', 'Cost', 'Reorder_Quantity', 'Unit_Size', 'Unit_Type']}
      // options.include = ['category']
      // options.include = [{ "all": true, "nested": true }]
      options.include = [
        { model: 'departments', attributes: ['Description'], required : true, include:['category']}, 
      ]
      this.$axios.get(`/api/${this.location}/inventory`, {params:options}).then((r)=>{
        let sorted = r.data.sort((a,b)=>a.Dept_ID > b.Dept_ID)
        const meta = {isEditing:false, isCloning:false, showAdvanced:false}
        this.inventory = sorted.map(row=>({meta:{...meta}, data:row}))
      });

      // i_axios.get(`/api/${this.location}/inventorySkus`).then((r)=>{
      //   this.inventorySkus = r.data;
      //   // r.data.forEach(row=>this.inventorySkusObject[row.ItemNum] = row);
      //   r.data.forEach(row=>this.inventorySkusObject[row.ItemNum] = []);
      //   r.data.forEach(row=>this.inventorySkusObject[row.ItemNum].push(row));
      //   console.log(this.inventorySkusObject);
      // });
    },
    toggleAdvanced: function(row){
      row.meta.showAdvanced = !row.meta.showAdvanced;
    },
    willEdit: function(row){
      console.log("edit", row)
      row.meta.isEditing = true;
      row.meta.before = {...row.data};
    },
    saveEdit: function(row){
      console.log("save edit", row);
      row.meta.after = {...row.data};
      row.meta.isEditing = false;
      console.log(row.meta.before, row.meta.after)
      
      let updateData = {}
      let changedKeys = Object.keys(row.meta.before).filter(k=>row.meta.before[k]!==row.meta.after[k])
      changedKeys.forEach(r=>updateData[r]=row.meta.after[r])

      i_axios.put(`/api/${this.location}/inventory/${row.data.ItemNum}`, updateData).then((r)=>{
        //Should Do Something Here
        console.log(r)
      });
    },
    willClone: function(row, location){
      console.log("clone", row)
      row.meta.before = {...row.data};
      row.meta.showAdvanced = false;
      row.meta.isCloning = true;
      row.meta.cloneLocation = location;
    },
    saveClone: function(row){
      console.log("save clone", row);
      row.meta.after = {...row.data};
      row.meta.isCloning = false;
      let params = {cloneTo : row.meta.cloneLocation, ...row.data}
      i_axios.post(`/inv/${this.location}/cloneItem/${row.meta.before.ItemNum}`, params).then((r)=>{
        console.log(r)
      })
    },
  },
  computed: {
    filteredInventory: function(){
      const result = this.inventory.filter(r=>{
        return r.data.ItemName.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        r.data.department.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        r.data.department.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        `${r.data.Vendor_Part_Num}`.toLowerCase().includes(this.ls.filterQuery.toLowerCase()) ||
        `${r.data.ItemNum}`.toLowerCase().includes(this.ls.filterQuery.toLowerCase())  ||
        r.meta.isEditing ||
        r.meta.isCloning
        // r.data.department.category.Description.toLowerCase().includes(this.ls.filterQuery.toLowerCase())
        })
      return result;
    }
  }
}
</script>

<style scoped>

</style>
